import { Link } from "react-router-dom";
import type { ReactNode } from "react";

/**
 * Layout compartido para páginas legales (Privacy / Terms).
 * Estilo sobrio on-brand, legible, con volver al inicio. Requerido por Meta
 * (política de privacidad enlazada) y por los carriers (A2P/10DLC) para SMS.
 */
export default function LegalLayout({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <main className="mx-auto min-h-[100dvh] max-w-2xl px-6 py-14 text-ink">
      <Link
        to="/"
        className="font-sans text-xs uppercase tracking-[0.2em] text-stone hover:text-clay"
      >
        ← A Couple &amp; A Dream
      </Link>

      <h1 className="mt-6 font-serif text-4xl leading-tight">{title}</h1>
      <p className="mt-2 text-sm text-stone">Last updated: {updated}</p>

      <div className="legal-prose mt-8 space-y-6 text-[15px] leading-relaxed text-ink/90">
        {children}
      </div>

      <footer className="mt-14 border-t border-stone/15 pt-6 text-sm text-stone">
        <p>
          A Couple &amp; A Dream is a brand of Javana Solutions LLC · Tampa Bay,
          Florida ·{" "}
          <a className="underline hover:text-clay" href="mailto:hello@acouplenadream.com">
            hello@acouplenadream.com
          </a>
        </p>
        <p className="mt-3 flex gap-4">
          <Link className="underline hover:text-clay" to="/privacy">
            Privacy Policy
          </Link>
          <Link className="underline hover:text-clay" to="/terms">
            Terms of Service
          </Link>
        </p>
      </footer>
    </main>
  );
}

/** Encabezado de sección reutilizable. */
export function H2({ children }: { children: ReactNode }) {
  return <h2 className="font-serif text-2xl text-ink">{children}</h2>;
}
